
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
    computed: {
        ...mapState({
            user: state => state.user.user,
            balance: state => state.user.user.balance,
        }),
        ...mapGetters('user', ['companyAuth', 'companyObj', 'auth']),
        serviceState() {
            var tmp = Date.parse(new Date()).toString().substring(0, 10)
            // 0未开通  1 服务中  已过期
            if (this.user.serviceUntil === null) {
                return {
                    key: 0,
                    value: '未开通'
                }
            } else if (this.user.serviceUntil > tmp) {
                return {
                    key: 1,
                    value: '服务中'
                }
            } else {
                return {
                    key: 2,
                    value: '已过期'
                }
            }
        },
        authType() {
            return this.authTypeFn(this.auth, this.companyAuth)
        },
    },
    mounted() {
        // this.getAccount();
    },
    methods: {
        ...mapActions("qiyeshiming", ["showMode1"]),
        ...mapActions("user", ["toAccountAuth","getAccount"]),
        ...mapActions("app", ["setUserDrawerShow"]),
        authTypeFn(auth, companyAuth) {
            if (!auth) {
                return 'unAuth';
            }
            if (!companyAuth) {
                return 'unCompanyAuth';
            }
            return 'allAuth'
        },
        tochongzhi() { // 跳转充值
            this.$utils.newopen('/accountCenter/balance/recharge?recharge=1')
        },
        //  验证个人实名
        verifyUserAuth() {
            return new Promise((resolve, reject) => {
                if (this.auth) {
                    resolve()
                } else {
                    this.toAccountAuth()
                }
            })
        },
        //  验证企业实名
        verifyCompanyAuth() {
            return new Promise((resolve, reject) => {
                if (this.companyAuth) {
                    resolve()
                } else {
                    this.showMode1()
                }
            })
        }
    }
}

